module.exports = "/images/vendor/flag-icon-css/flags/1x1/es-ga.svg?151714df0fea994ff25db833a9e9fea1";